<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mvu28S/tc-custom/9781571318756.jpg?1704918543907" alt="This image is the cover for the book Home Place"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Home Place
      </h1>
      <p class="bookDescription body article font2">
        <b>“A groundbreaking work about race and the American landscape, and a deep meditation on nature…wise and beautiful.”—Helen Macdonald, author of <i>H is for Hawk</i></b><br/>  <br/> A <i>Foreword Reviews</i> Best Book of the Year and Nautilus Silver Award Winner<br/>  <br/><i>In me, there is the red of miry clay, the brown of spring floods, the gold of ripening tobacco. All of these hues are me; I am, in the deepest sense, colored.</i><br/>  <br/> Dating back to slavery, Edgefield County, South Carolina—a place “easy to pass by on the way somewhere else”—has been home to generations of Lanhams. In <i>The Home Place</i>, readers meet these extraordinary people, including Drew himself, who over the course of the 1970s falls in love with the natural world around him. As his passion takes flight, however, he begins to ask what it means to be “the rare bird, the oddity.”<br/>  <br/> By turns angry, funny, elegiac, and heartbreaking, <i>The Home Place</i> is a meditation on nature and belonging by an ornithologist and professor of ecology, at once a deeply moving memoir and riveting exploration of the contradictions of black identity in the rural South—and in America today.<br/>  <br/> “When you’re done with <i>The Home Place</i>, it won’t be done with you. Its wonders will linger like everything luminous.”—<i>Star Tribune</i><br/>  <br/> “A lyrical story about the power of the wild…synthesizes his own family history, geography, nature, and race into a compelling argument for conservation and resilience.”—<i>National Geographic</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. Drew Lanham
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Milkweed Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0779cf1c